import { Suspense, lazy, useContext } from 'react';
import ObjectPrice from './ObjectPrice';
import QuickInfo from './QuickInfo/QuickInfo';
import ObjectBroker from './ObjectBroker';

import { ObjectPageContext } from '../../pages/Context/ObjectPageContext';
const ObjectViewing = lazy(() => import('./ObjectViewing'));

const ObjectSidebar = () => {
  const { isBigScreen } = useContext(ObjectPageContext);

  return (
    <aside
      id="overview"
      className="font-ic relative lg:w-full z-10 lg:flex lg:justify-between lg:flex-col lg:bg-blue100 object-sidebar lg:overflow-y-auto lg:h-[calc(100vh-64px)] lg:sticky lg:top-[64px] lg:right-0"
    >
      <div>
        <div className="px-3 lg:px-0 ">
          <ObjectPrice />
        </div>
        {isBigScreen && (
          <div className="lg:bg-blue100">
            <Suspense>
              <ObjectViewing />
            </Suspense>
          </div>
        )}
      </div>
      {isBigScreen === false && <QuickInfo />}
      <ObjectBroker />
    </aside>
  );
};
export default ObjectSidebar;
